var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 30,
    viewBox: "0 0 18 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 1.6665H12.0002C10.2321 1.6665 8.53636 2.36888 7.28612 3.61913C6.03587 4.86937 5.3335 6.56506 5.3335 8.33317V12.3332H1.3335V17.6665H5.3335V28.3332H10.6668V17.6665H14.6668L16.0002 12.3332H10.6668V8.33317C10.6668 7.97955 10.8073 7.64041 11.0574 7.39036C11.3074 7.14031 11.6465 6.99984 12.0002 6.99984H16.0002V1.6665Z",
    stroke: "white",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookWhite);
export default __webpack_public_path__ + "static/media/facebookWhite.b4fa7c87ca77643e82c1149905f2469f.svg";
export { ForwardRef as ReactComponent };